import React from 'react'
import { AnimatedIcon } from '@node-space/storybook-components/dist/AnimatedIcon'
import loader from '@node-space/storybook-components/dist/lottie/loader.json'

export const AnimatedIconLoader = () => {
  return <AnimatedIcon animationData={loader} width={80} height={80} />
}
